import { ResellerType } from '../../../super-admin/AdminResellerStats';
import React from 'react'

export interface ResellerStats {
  resellerId: string;
  resellerType: ResellerType;
  name: string;
  sold: number;
  supportSold?: number;
  afEarnings: number;
  earnings: number;
  supportEarnings?: number;
  isSupportable?: boolean;
}

interface ResellerStatsTableProps {
  stats: ResellerStats[];
  commissionSettings: {
    totalCommission: number;
    supportCommissionToMainAssociation: number;
    supportCommissionToAssociation: number;
  };
  isMainAssociation?: boolean;
}

const ResellerStatsTable: React.FC<ResellerStatsTableProps> = ({ stats, commissionSettings, isMainAssociation = false }) => {
  const gridColumns = isMainAssociation ? '2fr 1fr' : '2fr 2fr 1fr';

  const totalCommission = commissionSettings.totalCommission || 0;
  const supportCommissionToMainAssociation = commissionSettings.supportCommissionToMainAssociation || 0;
  const supportCommissionToAssociation = commissionSettings.supportCommissionToAssociation || 0;

  const pricePerUnit = isMainAssociation
    ? totalCommission
    : (totalCommission - supportCommissionToMainAssociation);

  const supportPricePerUnit = isMainAssociation
    ? (totalCommission - supportCommissionToAssociation)
    : supportCommissionToAssociation;

  const supportHelpText = isMainAssociation
    ? 'köp med vald stödförening'
    : 'stödandelar vid köp av huvudförening';

  return (
    <div className="webshop-stats-table">
      <div className="table-header" style={{ gridTemplateColumns: gridColumns }}>
        <span>Förening / Sålda</span>
        {!isMainAssociation && <span>ÅF:s förtjänst</span>}
        <span>Er förtjänst</span>
      </div>
      <div className="table-body box">
        {stats.map(({ resellerId, resellerType, name, sold, supportSold = 0, afEarnings, earnings, supportEarnings }) => {
          const resellerLabel = resellerType === ResellerType.Association ? 'föreningen' : resellerType === ResellerType.Team ? 'laget' : 'lagmedlemmen';

          return (
            <div className="table-row" style={{ gridTemplateColumns: gridColumns }} key={resellerId}>
              <span className="flex flex-col">
                <strong className='name-text'>{name}</strong>

                <small>
                  {sold} st (á {pricePerUnit} kr) {isMainAssociation
                    ? 'köp utan vald stödförening'
                    : `köp av ${resellerLabel}`}
                </small>

                {supportSold > 0 && (
                  <small>
                    {supportSold} st (á {supportPricePerUnit} kr) {supportHelpText}
                  </small>
                )}
              </span>
              {!isMainAssociation && (
                <span>
                  {supportEarnings && supportEarnings > 0 ? (
                    <div className='flex flex-col'>
                      <small className='inactive'>{afEarnings - supportEarnings} + {supportEarnings} =</small>
                      {afEarnings} kr
                    </div>
                  ) : (
                    <>{afEarnings} kr</>
                  )}
                </span>
              )}
              <span>
                <div className='flex flex-col'>
                  {isMainAssociation && (
                    <small className='inactive'>{totalCommission * sold} + {(totalCommission - supportCommissionToAssociation) * supportSold} =</small>
                  )}
                  {earnings} kr
                </div>
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ResellerStatsTable

